import React, { useEffect, useState, useRef } from "react";

import { Card, message } from "antd";
import "./claimMessagingView.scss";
import arabiclogo from "../../Assets/img/logoArabic.svg";
import moreInfo from "../../Assets/img/moreInfoChat.svg";
import filterImg from "../../Assets/img/messageFilterImg.svg";
import send from "../../Assets/img/send.svg";
import attachmentImg from "../../Assets/img/attachment.svg";
import blueDot from "../../Assets/img/blueDot.svg";
import allTenantCall from "../../Helpers/getAllTenantsCall";
import { reformatDateTime } from "../../Helpers/formatDate";
import { getTokenByUser, onMessageListener, storage } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import loading from "../../Assets/img/loading-gif-png-5.gif";
import getTenantByPayerName from "../../Helpers/getTenantByPayerName";
import axios from "axios";
import { axiosWithToken } from "../../AuthService/AxiosToken";
import { getClaimDetailsByID } from "../../Services/getClaimDetailsByID";
import ClaimDetailsDialog from "../../Pages/ClaimViewer/components/ClaimDetailsDialog";
function Notifications() {
  const [messageApi, contextHolder] = message.useMessage();
  const [isTokenFound, setIsTokenFound] = useState(false);
  const [allChats, setAllChats] = useState([]);
  const [chosenChat, setChosenChat] = useState({
    id: "",
    claimId: "",
    type: "",
    body: "",
    providerBranchId: "",
    payerName: "",
  });

  const [chatContent, setChatContent] = useState([]);
const [searchChat, setSearchChat] = useState([])
  const [isAttachmentLoading, setIsAttachmentLoading] = useState(false);

  const [notification, setNotification] = useState({
    notification: {},
  });
  const scrollRef = useRef(null);

  const [textFieldContent, setTextFieldContent] = useState("");
  const [shownTextFieldContent, setShownTextFieldContent] = useState("");
  const [appendAttachment, setAppendAttachement] = useState("")
  // Rest of the component code...
  const [openClaimDetails, setOpenClaimDetails] = useState({
    open: false,
  });

  useEffect(() => {
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
        allTenantCall("/provider/messaging", {})
      .then((response) => {
        console.log(response);
        setAllChats(response);
      })
      .catch((error) => console.log(error))
      } else if (document.visibilityState === "hidden") {
        console.log("Tab is now out of focus");
      }
    });
  }, []);

  useEffect(() => {
    setShownTextFieldContent(
      removeTextBetweenDoubleDollarSigns(textFieldContent)
    );
  }, [textFieldContent]);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  
  getTokenByUser(setIsTokenFound);

  onMessageListener().then((payload) => {
    if (chosenChat.id == payload.notification.title) {
      let chosenChatCp = { ...chosenChat };
      chosenChatCp.body = payload.notification.body;
      setNotification(chosenChatCp);
    } else {
      let chatFound = allChats.find(
        (chat) => chat.id == payload.notification.title
      );

      if (chatFound) {
        let allChatsCp = [...allChats];
        for (let i = 0; i < allChats.length; i++) {
          if (chatFound.id == allChatsCp[i].id) {
            allChatsCp[i].didProviderView = false;
            allChatsCp[i].body += payload.notification.body;
          }
        }
        setAllChats(allChatsCp);
      } else {
        const result = window.confirm(
          "A new message is received, reload the window?"
        );
        if (result) window.location.reload();
      }
    }
  });

  useEffect(() => {
    console.log("USE EFFECT ALL CHATS ", allChats);
  }, [allChats]);

  useEffect(() => {
    scrollToBottom();
    console.log("scrolll");
  }, [chatContent]);

  useEffect(() => {
    console.log("USEEFFECT NOTIF", notification);
    if (notification.id) {
      console.log("jansdkjnasdkjnasdjknajsdknkj");
      chooseChat(notification.id, notification.body);
    }
  }, [notification]);

  useEffect(() => {
    allTenantCall("/provider/messaging", {})
      .then((response) => {
        console.log(response);
        setAllChats(response);
      })
      .catch((error) => console.log(error));
  }, []);

  function handleSearchChat(text) {
    let search = allChats.filter((chat) => chat.claimId == text)
    console.log(search, "gasnubygasbijnbhyvtygbhj nhbvtygbh")
    setSearchChat(search)

  }

  function chooseChat(chatId, bodyToAppend) {
    let chosenChatCp = allChats.find((chat) => chat.id == chatId);

    let allChatsCp = [...allChats];

    for (let i = 0; i < allChatsCp.length; i++) {
      if (chosenChatCp.id == allChatsCp[i].id)
        allChatsCp[i].didProviderView = true;
    }

    chosenChatCp.body += bodyToAppend;
    const allMessages = chosenChatCp.body.split("~~");
    let chatMessagesDecoded = [];
    for (let message of allMessages) {
      if (message != "") {
        let messageObject = {};
        let messageIdentifiers = message.split("^#");
        messageObject.text = removeTextBetweenDoubleDollarSigns(
          messageIdentifiers[1]
        );
        messageObject.timestamp = messageIdentifiers[0].split("|")[0];
        messageObject.sender =
          messageIdentifiers[0].split("|")[1] == "TPA" ? false : true;

        if (!messageObject.sender)
          messageObject.providerBranchId = messageIdentifiers[0].split("|")[1];

        if (messageIdentifiers[1].includes("$$")) {
          messageObject.attachments = extractValuesBetweenDoubleDollarSigns(
            messageIdentifiers[1]
          );
        }

        chatMessagesDecoded.push(messageObject);
      }
    }
    setChatContent(chatMessagesDecoded);
    setChosenChat(chosenChatCp);
    setAllChats(allChatsCp);
    setAppendAttachement("")
  }

  function removeTextBetweenDoubleDollarSigns(str) {
    const regex = /\$\$.*?\$\$/g;
    const result = str.replace(regex, "");
    return result;
  }

  function extractValuesBetweenDoubleDollarSigns(str) {
    const regex = /\$\$(.*?)\$\$/g;
    const matches = str.match(regex) || [];
    const values = matches.map((match) => match.replace(/\$\$/g, ""));
    const nonEmptyValues = values.filter((value) => value.trim() !== "");
    return nonEmptyValues;
  }

  async function sendMessage() {
    //Make api call to send message
let textFieldContentCp = textFieldContent
textFieldContentCp += appendAttachment
setTextFieldContent(textFieldContentCp)
console.log(textFieldContent, appendAttachment, textFieldContentCp)
    axiosWithToken
      .post(
        process.env.REACT_APP_BASE_URL_B2B + "/provider/messaging",
        {
          payerName: chosenChat.payerName,
          text: textFieldContentCp,
          claimMessageId: chosenChat.id,
        },
        {
          headers: {
            authorization: `Bearer ${
              getTenantByPayerName(chosenChat.payerName).accessToken
            }`,
          },
        }
      )
      .then((_) => {
        let messageObject = {
          text: textFieldContentCp,
          timestamp: reformatDateTime(new Date()),
          sender: getTenantByPayerName(chosenChat.payerName).providerUserInfo
            .providerBranchId,
          attachments: [],
        };
        let chatContentCp = [...chatContent];

        if (messageObject.text.includes("$$")) {
          messageObject.attachments = extractValuesBetweenDoubleDollarSigns(
            messageObject.text
          );
        }

        messageObject.text = removeTextBetweenDoubleDollarSigns(
          messageObject.text
        );

        chatContentCp.push(messageObject);
        setChatContent(chatContentCp);

        let chosenChatCp = { ...chosenChat };
        chosenChatCp.body += textFieldContentCp;
        setChosenChat(chosenChatCp);
        let allChatsCp = [...allChats];

        let encodedText = `~~${reformatDateTime(new Date())}|${
          getTenantByPayerName(chosenChat.payerName).providerUserInfo
            .providerBranchId
        }^#${textFieldContent}`;

        for (let i = 0; i < allChatsCp.length; i++) {
          if (allChatsCp[i].id == chosenChat.id) {
            allChatsCp[i].body += encodedText;
          }
        }
        setAllChats(allChatsCp);
      })
      .catch((error) => console.log(error));
  }

  const handleAttachment = (file) => {
    const storageRef = ref(storage, `/chat-b2b/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    setIsAttachmentLoading(true);
    uploadTask.on(
      "state_changed",
      (_) => {},
      (err) => console.log(err),
      () => {
        // download url
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setIsAttachmentLoading(false);
          let textFieldContentCp = appendAttachment;
          textFieldContentCp += `$$${url}$$`;
          setAppendAttachement(textFieldContentCp);
        });
      }
    );
  };
  const openClaimDetailsHandler = (claimId, payerName) => {
    getClaimDetailsByID(claimId, {
      headers: {
        payerName: payerName,
        Authorization: `Bearer ${getTenantByPayerName(payerName).accessToken}`,
      }
    })
    .then(claimDetails =>{
      setOpenClaimDetails({
        open: true,
        claimDetails,
        payerName,
      });
    })
    .catch((error)=>{
      console.log(error);
      messageApi.open({
        type: "error",
        content: (Array.isArray(error) && error[0]) || "Something went wrong",
        duration: 5,
      });
    })
  }
  return (
    <>
      <div className="claimMessage-mainCont">
        {contextHolder}
        <p className="claimMessage-title"> Claim Updates</p>
        <div className="claimMessage-subCont">
          {chosenChat && chosenChat.id ? (
            <div className="claimMessage-chat">
              <Card
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "10px",
                  height: "100vh",
                }}
              >
                <span className="claimMessage-chat-top-section">
                  <img src={arabiclogo} style={{ width: "110px" }} />
                  <img src={moreInfo} />
                </span>
                <span className="claimMessage-chat-info-section">
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "20em",
                      justifyContent: "space-between",
                    }}
                  >
                    {chosenChat.id && (
                      <>
                        <p>
                          Claim Id <strong>{chosenChat.claimId} </strong>
                        </p>
                        <p style={{ margin: "0 1em" }}>23/4/2023 9.30AM</p>
                      </>
                    )}
                </span>

                  <button className="whiteButton" style={{ color: "gray" }} onClick={(e)=>{
                    openClaimDetailsHandler(chosenChat.claimId, chosenChat.payerName)
                  }}>
                 
                    Show Claim
                  </button>
                </span>
                <span className="claimMessage-chat-chat-section">
                  <span
                    ref={scrollRef}
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "scroll",
                      overflowX: "hidden",
                      height: "61vh",
                    }}
                  >
                    {chatContent &&
                      chatContent.length > 0 &&
                      chatContent.map((content) => {
                        return content.sender ? (
                          <div
                            style={{
                              backgroundColor: "#d2f4f2",
                              width: "60%",
                              margin: "1em 0",
                              padding: "1em",
                              alignSelf: "flex-end",
                              borderRadius: "10px 10px 0 10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "0.6em",
                              }}
                            >
                              <p>Sehatech</p>
                              <p>{content.timestamp}</p>
                            </div>
                            <p style={{width: "90%",   wordWrap: "break-word"}}>{content.text}</p>
                            {content.attachments &&
                              content.attachments.length > 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    width: "100%",
                                  }}
                                >
                                  {content.attachments.map((attachment) => {
                                    return (
                                      <a href={attachment} target="_blank">
                                        <img
                                          style={{
                                            width: "200px",
                                            height: "200px",
                                            margin: "0.5em",
                                            cursor: "pointer",
                                          }}
                                          src={attachment}
                                        ></img>
                                      </a>
                                    );
                                  })}
                                </div>
                              )}
                          </div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: "#f0f0f0",
                              width: "60%",
                              margin: "1em 0",
                              padding: "1em",
                              alignSelf: "flex-start",
                              borderRadius: "10px 10px 10px 0",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "0.6em",
                              }}
                            >
                              <p>{content.providerBranchId}</p>
                              <p>{content.timestamp}</p>
                            </div>
                            <div>
     <p style={{width: "90%",  wordWrap: "break-word"}}>{content.text}</p>
                            {content &&
                              content.attachments &&
                              content.attachments.map((attachment) => {
                                return (
                                  <a href={attachment} target="_blank">
                                    <img
                                      style={{
                                        width: "200px",
                                        height: "200px",
                                        margin: "0.5em",
                                        cursor: "pointer",
                                      }}
                                      src={attachment}
                                    ></img>
                                  </a>
                                );
                              })}
                            </div>
                       
                          </div>
                        );
                      })}
                  </span>
                </span>
                <span className="claimMessage-chat-input-section">
                  <div style={{width: "84%"}}>
                  <span className="inputMessage">
                    {" "}
                    <textarea
                      className="inputMessageField"
                      required
                      style={{ resize: "none" }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault(); // Prevent form submission
                          sendMessage();
                          setTextFieldContent("");
                        }
                      }}
                      placeholder="Write your message here"
                      value={textFieldContent.replace(/\$\$.*?\$\$/g, '')}
                      onChange={(e) => {

                        setTextFieldContent(e.target.value);
                      }}
                    />{" "}
                    <div>
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          handleAttachment(e.target.files[0]);
                        }}
                      />
                      <label htmlFor="fileInput">
                        <img
                          style={{
                            cursor: "pointer",
                            width: "1.2em",
                            margin: "0 0.4em",
                          }}
                          src={attachmentImg}
                          alt="Select Image"
                        />
                      </label>
                    </div>
                  </span>
                  {appendAttachment && appendAttachment&& extractValuesBetweenDoubleDollarSigns(appendAttachment).map((attach, index) => {
                   
                    return <span style={{padding: "0.6em", border: "solid 0.1em #54545454", marginLeft: "0.4em"}}>
                    attachment {index+1}
                  </span>
                })}
                  </div>
                 
                  <button
                    className="buttonSend"
                    disabled={isAttachmentLoading}
                    onClick={() => {
                      sendMessage();
                      setTextFieldContent("");
                    }}
                  >
                    Send{" "}
                    {isAttachmentLoading ? (
                      <img width={"30px"} src={loading} />
                    ) : (
                      <img style={{ transform: "rotate(180deg)" }} src={send} />
                    )}
                  </button>
                </span>
              </Card>
            </div>
          ) : <div/>}
          <div className="claimMessage-list">
            <Card
              style={{ borderRadius: "10px", width: "100%", height: "85vh",  overflow: "scroll"}}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "inherit"
                }}
              >
                <span className="claimMessage-list-topSection">
                  <input style={{ height: "30px", width: "90%" }}
                      placeholder="search (using claimId)"                  
                  onChange={(e) => {
                        handleSearchChat(e.target.value)
                  }}></input>
                  <img src={filterImg} style={{ width: "40px" }} />
                </span>
                <span style={{ display: "flex", flexDirection: "column" }}>
                  { searchChat && searchChat.length > 0 ?
                    searchChat.map((chat) => {
                      let style = {
                        width: "100%",
                        padding: "1em 0.5em",
                        borderBottom: "solid 0.1em #545454",
                        cursor: "pointer",
                      };
                      if (chat.id == chosenChat.id)
                        style.backgroundColor = "#f0f0f090";
                      return (
                        <div
                          style={style}
                          onClick={() => {
                            chooseChat(chat.id, "");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <p>
                                <strong>{chat.claimId}</strong> رقم المطالبة
                              </p>
                              {!chat.didProviderView && (
                                <img
                                  src={blueDot}
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    margin: "0 10px",
                                  }}
                                ></img>
                              )}
                            </div>
                            <p style={{ color: "grey" }}>
                              {reformatDateTime(chat.updatedAt)}
                            </p>
                          </div>
                          <div style={{ marginTop: "20px" }}>
                            <p style={{ color: "grey" }}>
                              {chat.body.substring(0, 40)} ...
                            </p>
                          </div>
                        </div>
                      );
                    }): allChats && allChats.length > 0 &&  allChats.map((chat) => {
                      let style = {
                        width: "100%",
                        padding: "1em 0.5em",
                        borderBottom: "solid 0.1em #545454",
                        cursor: "pointer",
                      };
                      if (chat.id == chosenChat.id)
                        style.backgroundColor = "#f0f0f090";
                      return (
                        <div
                          style={style}
                          onClick={() => {
                            chooseChat(chat.id, "");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <p>
                                <strong>{chat.claimId}</strong> رقم المطالبة
                              </p>
                              {!chat.didProviderView && (
                                <img
                                  src={blueDot}
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    margin: "0 10px",
                                  }}
                                ></img>
                              )}
                            </div>
                            <p style={{ color: "grey" }}>
                              {reformatDateTime(chat.updatedAt)}
                            </p>
                          </div>
                          <div style={{ marginTop: "20px" }}>
                            <p style={{ color: "grey" }}>
                              {chat.body.substring(0, 40)} ...
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </span>
              </div>
            </Card>
          </div>
        </div>
      </div>
      {openClaimDetails.open && <ClaimDetailsDialog open={openClaimDetails.open} close={()=>setOpenClaimDetails({open:false})} claimDetails={openClaimDetails.claimDetails} payerName={openClaimDetails.payerName} messageApi={messageApi}/>}
    </>
  );
}

export default Notifications;

